import { HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiService, OrderDetails } from '@overtur-monorepo/keying-shared'
import { BehaviorSubject, Observable } from 'rxjs'
import { HierarchyConfig } from '../../configuration/keying.hierarchy.environment.config'

@Injectable({
  providedIn: 'root',
})
export class OrderLookupService {
  orderDetails = new BehaviorSubject<OrderDetails[]>([])
  orderDetails$ = this.orderDetails.asObservable()
  httpHeaders: HttpHeaders
  serviceEndpoint: string

  /* istanbul ignore next */
  constructor(private api: ApiService, private config: HierarchyConfig) {}

  /* istanbul ignore next */
  getOrderDetails(
    orderNumber?: string,
    structureNumber?: string,
    userId?: number,
    timeRangeInDays?: number
  ): Observable<OrderDetails[]> {
    if (orderNumber) {
      this.buildRequestByOrderNumber(orderNumber)
    } else if (structureNumber) {
      this.buildRequestByStructureNumber(structureNumber)
    }

    this.buildQueryParams(userId, timeRangeInDays)

    return this.api.get<OrderDetails[]>(this.buildUrl(), this.httpHeaders)
  }

  /* istanbul ignore next */
  getOrderEntryStatus(requestId: string): Observable<string> {
    this.serviceEndpoint = `OrderEntry/${requestId}/status`
    this.httpHeaders = new HttpHeaders().set(
      'Content-type',
      'application/allegion.keying.get.order.entry.order.status+json'
    )
    return this.api.get<string>(this.buildUrl(), this.httpHeaders)
  }

  /* istanbul ignore next */
  getRestrictedProductStatus(orderNumber: string, requestId: string): Observable<string> {
    this.serviceEndpoint = `RestrictedProduct/${orderNumber}/${requestId}/status`
    this.httpHeaders = new HttpHeaders().set(
      'Content-type',
      'application/allegion.keying.get.restricted.product.order.status+json'
    )
    return this.api.get<string>(this.buildUrl(), this.httpHeaders)
  }

  /* istanbul ignore next */
  buildRequestByOrderNumber(orderNumber: string) {
    this.serviceEndpoint = `OrderLookup/${orderNumber}`
    this.httpHeaders = new HttpHeaders().set(
      'Content-type',
      'application/allegion.keying.get.order.details.by.orderNumber+json'
    )
  }

  /* istanbul ignore next */
  buildRequestByStructureNumber(structureNumber: string) {
    this.serviceEndpoint = `OrderLookup/${structureNumber}`

    this.httpHeaders = new HttpHeaders().set(
      'Content-type',
      'application/allegion.keying.get.order.details.by.structureNumber+json'
    )
  }

  /* istanbul ignore next */
  buildQueryParams(userId?: number, timeRangeInDays?: number) {
    if (userId && timeRangeInDays) {
      this.serviceEndpoint = `${this.serviceEndpoint}?userId=${userId}&timeRangeInDays=${timeRangeInDays}`
    } else if (userId) {
      this.serviceEndpoint = `${this.serviceEndpoint}?userId=${userId}`
    } else if (timeRangeInDays) {
      this.serviceEndpoint = `${this.serviceEndpoint}?timeRangeInDays=${timeRangeInDays}`
    }
  }

  /* istanbul ignore next */
  private buildUrl(): string {
    return `${this.config.baseUrl}/${this.serviceEndpoint}`
  }
}
